// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"480":"9d1ed77b","531":"1ecf3cab","650":"ebc5778c","750":"40d82070"}[chunkId] + ".css";
};